import { Suspense } from 'react';
import { Outlet } from 'react-router';

import useAccountQuery from 'api/queries/useAccountQuery';
import Loader from 'honeydew/Loader';

function ProductDetailPageLayout() {
    const { data: account } = useAccountQuery();

    if (!account?.nextOrder?.chargeID) {
        return (
            <div className="mt-[140px] flex justify-center">
                <Loader />
            </div>
        );
    }

    return (
        <Suspense fallback={<Loader />}>
            <Outlet />
        </Suspense>
    );
}

export default ProductDetailPageLayout;
